import request from '@/utils/request'
export default {
  // 新增修改商铺信息
  addOrEditShop(method,data) {
    return request({
      url:'/system/shop',
      method,
      data
    })
  },
  // 删除商铺列表
  delShop(id) {
    return request({
      url: `/system/shop/${id}`,
      method:'delete'
    })
  },
  // 查询商铺信息列表
  getShopList(params) {
    return request({
      url:'/system/shop/list',
      method:'get',
      params
    })
  }
}